// Module
var code = "<account-page></account-page> ";
// Exports
export default code;